/* eslint-disable require-jsdoc */
/**
CREATIVE CODING
---
Kill server : CTRL + C
Start server : npm run start
Final build : npm run build
---
**/

import AxL from "./axl";
import { IRWN } from "./irwn/IRWN";
export default class App {
  constructor() {
    // //AXL TEMPLATE FOR GOOGLE EXPERIMENT
    this.axl = new AxL();
    this.initialised = false;
    this.initAxL();
  }
  initAxL() {
    const gotFirstResume = new Promise((resolve) => {
      this.axl.registerMessageCallback(AxL.HostToChild.RESUME, (payload) => {
        resolve();
      });
      console.log("IRWN__v0.0.8");
      // TODO launch straight into app when testing in dev environment
      // if (!this.initialised) {
      //   this.initIRWN();
      // }
    });

    const gameReady = this.axl.handshake().then((initialData) => {
      AxL.initialData = initialData;
      console.log("handshake is done", initialData);
      const objJsonStr = JSON.stringify(initialData);

      if (initialData.hidden_breathe_btn) document.body.classList.add('irwn-hide-buttons');
    });

    // Make sure game is initialized AND we got the first resume call
    Promise.all([gotFirstResume, gameReady]).then(() => {
      console.log("init app");
      this.initIRWN();
    });
  }
  initIRWN() {
    this.initialised = true;
    IRWN.init(this.axl);
  }
}
